var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMoreInformation = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM6.5625 3.9375C6.5625 3.69588 6.75838 3.5 7 3.5C7.24162 3.5 7.4375 3.69588 7.4375 3.9375V6.5625H10.0625C10.3041 6.5625 10.5 6.75838 10.5 7C10.5 7.24162 10.3041 7.4375 10.0625 7.4375H7.4375V10.0625C7.4375 10.3041 7.24162 10.5 7 10.5C6.75838 10.5 6.5625 10.3041 6.5625 10.0625V7.4375H3.9375C3.69588 7.4375 3.5 7.24162 3.5 7C3.5 6.75838 3.69588 6.5625 3.9375 6.5625H6.5625V3.9375Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMoreInformation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/moreInformation.cec329fe.svg";
export { ForwardRef as ReactComponent };